export default __webpack_public_path__ + "static/media/copy_icon.71106c6a.svg";